export default __webpack_public_path__ + "static/media/i (5).93e54ee8.jpg";